// extracted by mini-css-extract-plugin
export default {"container":"ConfirmationMW_container__UVh7B","title":"ConfirmationMW_title__UUtTj","btn_container":"ConfirmationMW_btn_container__a8jd3"};